import React, { useEffect } from "react";

import "../index.css";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";




const Home = () => {
  const history = useNavigate();
  const accessToken = secureLocalStorage.getItem("token");
  useEffect(() => {
    if (!accessToken) {
      history("/");
    }
  }, [])

  return (
    <div className="">
      <div>
        <Header />
      </div>
      <div className="inner-image-header">
        <div className="inner-image-text">
          <p>
            Welcome to <strong>AL ASAB</strong>
          </p>
        </div>
      </div>
      <div className="content--container"></div>
      <div className="footerFooter">
        <Footer />
      </div>
    </div>
  );
};

export default Home;
